module.exports = __webpack_public_path__ + "static/media/Invalid.80b5cd01.svg";